export const MB = 1024 * 1024;

export const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minut
export const WARNING_SESSION_TIMEOUT = 1 * 60 * 1000; // 1 minut